var map = {
	"./chatDefaultImg.png": "8139",
	"./course.png": "f4c9",
	"./default_cover.png": "926d",
	"./editor-logo.png": "feef",
	"./exam.png": "28b2",
	"./file.png": "87d4",
	"./friend_image_text.png": "4bc8",
	"./friend_text.png": "b356",
	"./friend_video_text.png": "afe2",
	"./getUrlTips1.png": "406b",
	"./getUrlTips2.png": "0f4d",
	"./glst.png": "f42f",
	"./h5.png": "2dc3",
	"./image-placeholder.png": "04d5",
	"./image.png": "bf05",
	"./logo-upload.png": "ef7d",
	"./minipro.png": "7300",
	"./mp3.png": "4ab6",
	"./no-card.png": "464a",
	"./no-data.png": "ac8d",
	"./pdf.png": "b9de",
	"./phone.png": "1e37",
	"./play-button-hover.png": "5dcb",
	"./play-button.png": "edfd",
	"./ppt.png": "fe3ee",
	"./redIcon0.png": "cc8a",
	"./redIcon1.png": "d6ae",
	"./shape.png": "28e8",
	"./share-settings-pic.png": "5b51",
	"./txt.png": "5c63",
	"./user.png": "ba97",
	"./video.png": "c59e",
	"./voice-left-01.png": "a391",
	"./voice-left-02.png": "1a1a",
	"./voice-left-03.png": "575b",
	"./voice-right-01.png": "b0d4",
	"./voice-right-02.png": "84cd",
	"./voice-right-03.png": "eece",
	"./word.png": "dccb",
	"./xlsx.png": "08f8",
	"./yxst.png": "ef64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";